import { fork } from 'redux-saga/effects';

import getPageDataSaga from './getPageDataSaga';
import saveDefaultSettingsSaga from './saveDefaultSettingsSaga';

export default [fork(getPageDataSaga), fork(saveDefaultSettingsSaga)];
